import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation_en from './en';
import translation_es from './es';
import translation_fr from './fr';
import translation_ge from './ge';
import translation_it from './it';
import translation_jp from './jp';
import translation_sc from './sc';
import translation_tc from './tc';
import translation_ar from './ar';
import translation_ko from './ko';
import translation_pl from './pl';
import translation_nl from './nl';
import translation_pt from './pt';
import translation_ro from './ro';
import translation_vi from './vi';
import translation_id from './id';
import translation_th from './th';
import translation_ms from './ms';
import translation_ru from './ru';

const resources = {
    en: {
        translation: translation_en
    },
    es: {
        translation: translation_es
    },
    fr: {
        translation: translation_fr
    },
    ge: {
        translation: translation_ge
    },
    it: {
        translation: translation_it
    },
    jp: {
        translation: translation_jp
    },
    sc: {
        translation: translation_sc
    },
    tc: {
        translation: translation_tc
    },
    ar: {
        translation: translation_ar
    },
    ko: {
        translation: translation_ko
    },
    pl: {
        translation: translation_pl
    },
    nl: {
        translation: translation_nl
    },
    pt: {
        translation: translation_pt
    },
    ro: {
        translation: translation_ro
    },
    vi: {
        translation: translation_vi
    },
    id: {
        translation: translation_id
    },
    th: {
        translation: translation_th
    },
    ms: {
        translation: translation_ms
    },
    ru: {
        translation: translation_ru
    },
};

export const SUPPORTED_LOCALES = Object.keys(resources);

// console.log('i18n init')
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en", // 默认语言
        fallbackLng: "en", // 当当前语言的翻译缺失时回退到该语言
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/locales/index.js